import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { IconBell } from '@wegic/icon';
import { Tooltip, Trigger } from '@wegic/ui';
import '@wegic/ui/dist/components/Tooltip/index.css';
import classNames from 'classnames';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleNotificationAction as handleNotificationActionBase } from '@/components/DropDownMenu/helper';
import MobileBottomSheet from '@/components/MobileBottomSheet';
import { NotificationPanel, useNotification } from '@/components/NotificationCenter';
import { isMobile } from '@/const/browser';
import { collect } from '@/modules/Collect/helper';
import styles from './index.module.less';
function NotificationButton(props) {
    const { collapsed = false } = props;
    const [visible, setVisible] = useState(false);
    const notification = useNotification();
    const navigate = useNavigate();
    const closeNotification = ()=>{
        setVisible(false);
    };
    const openNotification = ()=>{
        setVisible(true);
        notification.onPanelOpen();
        collect('notification_panel_open', {
            unread_count: notification.unreadCount,
            update_unread: notification.updateUnread,
            for_you_unread: notification.forYouUnread
        });
    };
    const handleVisibleChange = (nextVisible)=>{
        if (nextVisible) {
            openNotification();
            return;
        }
        closeNotification();
    };
    const handleNotificationPanelAction = (item, action)=>{
        handleNotificationActionBase(item, action, {
            navigate,
            onClose: closeNotification
        });
    };
    const notificationButton = /*#__PURE__*/ _jsxs("button", {
        className: classNames(styles['notification-button'], {
            [styles['notification-button-open']]: visible
        }),
        type: "button",
        "aria-label": "Notifications",
        "aria-haspopup": "dialog",
        "aria-expanded": visible,
        children: [
            /*#__PURE__*/ _jsx(IconBell, {
                fontSize: 16
            }),
            notification.unreadCount > 0 && /*#__PURE__*/ _jsx("span", {
                className: styles['notification-dot']
            })
        ]
    });
    const notificationPanel = /*#__PURE__*/ _jsx(NotificationPanel, {
        notifications: notification.notifications,
        loading: notification.loading,
        selectedId: notification.selectedId,
        selectedNotification: notification.selectedNotification,
        unreadCount: notification.unreadCount,
        updateUnread: notification.updateUnread,
        forYouUnread: notification.forYouUnread,
        activeTab: notification.activeTab,
        onSwitchTab: notification.switchTab,
        onSelect: notification.selectNotification,
        onGoBack: notification.goBack,
        onMarkAllAsRead: notification.markAllAsRead,
        onLoadMore: notification.loadMore,
        onClose: closeNotification,
        onAction: handleNotificationPanelAction,
        showCloseButton: !isMobile
    });
    if (isMobile) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("button", {
                    className: classNames(styles['notification-button'], {
                        [styles['notification-button-open']]: visible
                    }),
                    type: "button",
                    "aria-label": "Notifications",
                    "aria-haspopup": "dialog",
                    "aria-expanded": visible,
                    onClick: visible ? closeNotification : openNotification,
                    children: [
                        /*#__PURE__*/ _jsx(IconBell, {
                            fontSize: 16
                        }),
                        notification.unreadCount > 0 && /*#__PURE__*/ _jsx("span", {
                            className: styles['notification-dot']
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(MobileBottomSheet, {
                    visible: visible,
                    ariaLabel: intl.get('workspace.notifications.title'),
                    onClose: closeNotification,
                    children: notificationPanel
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(Trigger, {
        trigger: "click",
        position: "right",
        popupAlign: {
            right: 8
        },
        popupVisible: visible,
        boundaryDistance: {
            right: 10,
            bottom: 10
        },
        clickOutsideToClose: {
            capture: true
        },
        onVisibleChange: handleVisibleChange,
        popup: ()=>notificationPanel,
        updateOnScroll: true,
        children: collapsed ? /*#__PURE__*/ _jsx(Tooltip, {
            content: intl.get('workspace.notifications.title'),
            position: "right",
            triggerProps: {
                mouseEnterDelay: 200
            },
            children: notificationButton
        }) : notificationButton
    });
}
export default NotificationButton;
